'use client'

import {
  useFetchDetailPtkSummary,
  useFetchMasterSatdikDetail,
} from '@/apis/useDataInduk'

import { ResponsiveModal } from '@/components/ResponsiveModal/ResponsiveModal'

import { SatdikDetailContent } from './Content/SatdikDetailContent'
import { SatdikDetailProps } from './types'

export function SatdikDetailResponsive({
  npsn,
  withPtkSummary = false,
  show,
  onClose,
}: SatdikDetailProps) {
  const { data: dataMasterSatdik, status } = useFetchMasterSatdikDetail(npsn, {
    enabled: Boolean(show && !!npsn),
  })

  const { data: dataPtkSummary } = useFetchDetailPtkSummary(npsn, {
    enabled: Boolean(show && withPtkSummary && !!npsn),
  })

  return (
    <ResponsiveModal
      show={show}
      onClose={onClose}
      size={withPtkSummary ? 'lg' : 'md'}
      title={
        dataMasterSatdik?.satuanPendidikan?.nama || 'Detail Satuan Pendidikan'
      }
    >
      <SatdikDetailContent
        status={status}
        masterData={dataMasterSatdik?.satuanPendidikan}
        lastUpdatedAt={dataMasterSatdik?.meta?.lastUpdatedAt}
        withHeader={false}
        withPtkSummary={withPtkSummary}
        ptkSummary={dataPtkSummary}
      />
    </ResponsiveModal>
  )
}
